// Local fallback metadata (mirrors backend). Backend remains source of truth.
export const DEPARTMENTS = {
  "mens-football": {
    slug: "mens-football",
    name: "Men's Football",
    short: "Men's",
    sport: "football",
    gender: "men",
    accent: "#00E5FF",
    logo: "/assets/logos/mens-football.png",
    instagram: "https://www.instagram.com/completesportsgroup",
    hero_image:
      "https://images.unsplash.com/photo-1553778263-73a83bab9b0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxtZW5zJTIwZm9vdGJhbGwlMjBtYXRjaCUyMGFjdGlvbnxlbnwwfHx8fDE3Nzg5MTU1MjV8MA&ixlib=rb-4.1.0&q=85",
    tagline: "Built for the Modern Footballer.",
  },
  "womens-football": {
    slug: "womens-football",
    name: "Women's Football",
    short: "Women's",
    sport: "football",
    gender: "women",
    accent: "#5CFF99",
    logo: "/assets/logos/womens-football.png",
    instagram: "https://www.instagram.com/completesportsgroupw",
    hero_image: "/assets/womens-football-hero.png",
    tagline: "The Future of Women's Football.",
  },
  "mens-cricket": {
    slug: "mens-cricket",
    name: "Men's Cricket",
    short: "Men's",
    sport: "cricket",
    gender: "men",
    accent: "#1F44FF",
    logo: "/assets/logos/mens-cricket.png",
    instagram: "https://www.instagram.com/csgcricket",
    hero_image: "/assets/mens-cricket-hero.png",
    tagline: "Crafted for the International Stage.",
  },
  "womens-cricket": {
    slug: "womens-cricket",
    name: "Women's Cricket",
    short: "Women's",
    sport: "cricket",
    gender: "women",
    accent: "#FF1F6B",
    logo: "/assets/logos/womens-cricket.png",
    instagram: "https://www.instagram.com/csgcricketw",
    hero_image: "/assets/womens-cricket-hero.png",
    tagline: "Defining a New Era in Women's Cricket.",
  },
  "commercial": {
    slug: "commercial",
    name: "Commercial",
    short: "Commercial",
    sport: "commercial",
    gender: null,
    accent: "#F0B429",
    logo: "/assets/logos/mens-football.png",
    instagram: "https://www.instagram.com/completecomms",
    hero_image:
      "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=1600&q=85",
    tagline: "Deals That Define Legacies.",
  },
};

// Top-level sections shown on the landing page
export const SECTIONS = [
  {
    slug: "football",
    name: "Football",
    href: "/sport/football",
    image:
      "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=1600&q=85",
    description:
      "Representing footballers across the men's and women's elite game.",
    colors: ["#00E5FF", "#5CFF99"],
  },
  {
    slug: "cricket",
    name: "Cricket",
    href: "/sport/cricket",
    image:
      "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1600&q=85",
    description:
      "Backing the cricketers shaping the modern international game.",
    colors: ["#1F44FF", "#FF1F6B"],
  },
  {
    slug: "commercial",
    name: "Commercial",
    href: "/d/commercial",
    image:
      "https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=1600&q=85",
    description:
      "Brand partnerships, endorsements and off-the-pitch deals.",
    colors: ["#F0B429", "#F0B429"],
  },
];

export const SPORTS = {
  football: {
    name: "Football",
    departments: ["mens-football", "womens-football"],
    image:
      "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=1600&q=85",
  },
  cricket: {
    name: "Cricket",
    departments: ["mens-cricket", "womens-cricket"],
    image:
      "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1600&q=85",
  },
};
